import useProtocolHandler from 'core/hooks/use-protocol-handler';
import { Loader } from 'hfs-common-ui';

const OpenPWA = () => {
  useProtocolHandler();
  return (
    <div>
      <Loader center size="large" />
    </div>
  );
};

export default OpenPWA;
